module.exports = __webpack_public_path__ + "static/osiedle-bogucianka-cb243ef7e6bc73ff78f827e87295ec0d.png";